module.exports = __webpack_public_path__ + "img/B高通锐化10.264a8f12.png";